<template lang="html">
<div class="pgInner pk_edit">

    <div class="headBar">新建服务包</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <el-form ref="ruleForm" :model="params" :rules="rules" inline-message="true" :show-message="false">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">标题</div>
                     <div class="bContent">
                           <el-form-item prop="title">
                               <el-input size="medium" class="inpText" v-model="params.title" placeholder="请输入"></el-input>
                           </el-form-item>
                     </div>
                 </div>


                 <div class="select-line">

                     <div class="selectGp">
                           <div class="cName">分类</div>
                           <el-form-item prop="subjectTypeId">
                               <dic-select code="fwblx"
                                    :selectId="params.subjectTypeId"
                                    paramsKey="subjectType"
                                    @selectChange="selectChange"
                                    plaText="主体类型" />
                           </el-form-item>
                     </div>

                     <div class="selectGp">
                           <div class="cName">管家姓名</div>
                           <el-form-item prop="housekeeperName">
                               <el-input size="medium" class="inpText" v-model="params.housekeeperName" placeholder="请输入"></el-input>
                           </el-form-item>
                     </div>

                     <div class="selectGp">
                          <div class="cName">管家电话</div>
                           <el-form-item prop="housekeeperPhone">
                               <el-input size="medium" class="inpText" v-model="params.housekeeperPhone" placeholder="请输入"></el-input>
                           </el-form-item>
                     </div>

                 </div>

                 <div class="select-line">

                     <div class="selectGp">
                          <div class="cName">部门</div>
                           <el-form-item prop="department">
                               <el-input size="medium" class="inpText" v-model="params.department" placeholder="请输入"></el-input>
                           </el-form-item>
                     </div>

                     <div class="selectGp">
                           <div class="cName">主管领导</div>
                           <el-form-item prop="executiveLeader">
                               <el-input size="medium" class="inpText" v-model="params.executiveLeader" placeholder="请输入"></el-input>
                           </el-form-item>
                     </div>

                 </div>

                 <div class="text-block scene-block clearfix">
                     <div class="bName">简介</div>
                     <div class="bContent">
                           <el-form-item style="width:100%;" prop="contextSummary">
                               <el-input maxlength="20" type="textarea" style="width:35%;" size="medium" v-model="params.contextSummary" placeholder="不超过20字"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block scene-block clearfix">
                     <div class="bName">内容</div>
                     <div class="bContent">
                         <textEditor ref="textEditor" :inContent="params.context" />
                         <!-- <editor id="editor_id" height="500px" width="100%" :content="params.context"
                         @on-content-change="contentChange"
                         pluginsPath="/static/kindeditor/plugins/"
                         :loadStyleMode="false"></editor> -->
                     </div>
                 </div>

                 <div class="text-block img-block clearfix">
                     <div class="bName">封面图片</div>
                     <div class="bContent">
                           <img-upload :image="params.image" @imgChange="imgChange" tips="（115*70推荐）"  />
                     </div>
                 </div>


                 <div class="text-block radio-block clearfix">
                     <div class="bName">可见范围</div>
                     <div class="bContent">
                         <el-radio-group v-model="radioType">
                            <el-radio border size="medium" :label="1">全部</el-radio>
                            <el-radio disabled border size="medium" :label="2">指定类型</el-radio>
                            <el-radio border size="medium" :label="3">指定企业</el-radio>
                            <el-radio border size="medium" :label="4">指定用户</el-radio>

                         </el-radio-group>
                     </div>
                 </div>

                 <div class="text-block check-block clearfix">
                     <div class="bName"></div>
                     <div class="bContent">
                         <div v-if="radioType==2">
                             <el-checkbox-group v-model="idArr1">
                                 <el-checkbox v-for="(item,index) in selectList1" :key="index" :label="item.id">{{item.name}}</el-checkbox>
                             </el-checkbox-group>
                         </div>
                         <div v-if="radioType==3" class="check-seek">
                             <div class="seek-head">
                                 <i class="el-icon-search"></i>
                                 <el-select
                                     filterable
                                     remote
                                      @change="handleChange"
                                      :remote-method="entSeek"
                                      :loading="loading1"
                                      v-model="entId"
                                      placeholder="搜索企业名称">

                                     <el-option
                                       v-for="item in selectList2"
                                       :key="item.id"
                                       :label="item.companyName"
                                       :value="item.id">
                                     </el-option>

                                 </el-select>

                                 <el-button @click="entSelect" style="margin-left:12px;" size="medium" type="primary">添加</el-button>
                             </div>
                             <div class="seek-body">
                                 <el-tag
                                   v-for="(item,index) in idArr2"
                                   :key="index"
                                   type="danger"
                                   @close="entRemove(index)"
                                   closable>
                                   {{item.name}}
                                 </el-tag>
                             </div>
                         </div>
                         <div v-if="radioType==4" class="check-seek">
                             <div class="seek-head">
                                 <i class="el-icon-search"></i>
                                 <el-select
                                      filterable
                                      remote
                                      :remote-method="userSeek"
                                      :loading="loading2"
                                      v-model="userId"
                                      placeholder="搜索用户">
                                     <el-option
                                       v-for="item in selectList3"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                                       <span>{{ item.name }}</span>
                                       <span>（{{ item.enterpriseName }}）</span>
                                     </el-option>

                                 </el-select>

                                 <el-button @click="userSelect" style="margin-left:12px;" size="medium" type="primary">添加</el-button>
                             </div>
                             <div class="seek-body">
                                 <el-tag
                                   v-for="(item,index) in idArr3"
                                   :key="index"
                                   type="danger"
                                   @close="userRemove(index)"
                                   closable>
                                   {{item.name}}（{{item.enterpriseName}}）
                                 </el-tag>
                             </div>
                         </div>
                     </div>
                 </div>

               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

        <el-button @click="directSave(1)" type="primary" size="small">立即发布</el-button>
        <el-button @click="directSave(2)" plain size="small">保存</el-button>
        <el-button @click="goReturn" plain size="small">取消</el-button>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import { pkCreate,pkPredat } from "@/api/enterprise/index";
import { dicSeek } from "@/api/pgMent/dictMent";
import { getEnterpriseList } from "@/api/attes/attestation";
import { getEntUser } from "@/api/enterprise/index";

export default {
    components:{
        Editor
    },
    data(){
        return{
            idArr1:[],   // 指定类型
            idArr2:[],   // 指定企业
            idArr3:[],   // 指定用户

            entClassMap:{},

            radioType:1,

            entId:'',
            entMap:{},
            loading1:false,

            userId:'',
            userMap:{},
            loading2:false,

            selectList1:[],
            selectList2:[],
            selectList3:[],

            pageH:'',
            params:{

                id:'',
                title:'',

                type:1,

                subjectType:'',
                subjectTypeId:'',

                housekeeperName:'',
                housekeeperPhone:'',

                contextSummary:'',
                department:'',
                executiveLeader:'',
                context:'',
                image:'',

                visibleRangeType:'',
                visibleRangeUser:'',
                visibleRangeEnterprise:''

            },

            rules:{
                title:[{
                      required: true,
                      trigger: 'blur'
                }],
                subjectTypeId:[{
                      required: true,
                      trigger: 'change'
                }],
                housekeeperName:[{
                      required: true,
                      trigger: 'blur'
                }],
                housekeeperPhone:[{
                      required: true,
                      trigger: 'change'
                }],
                department:[{
                      required: true,
                      trigger: 'blur'
                }],
                contextSummary:[{
                      required: true,
                      trigger: 'blur'
                }],
                executiveLeader:[{
                      required: true,
                      trigger: 'change'
                }]
            }

        }
    },

    methods:{
        goReturn:function(){
            this.$router.go(-1);
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },
        selectChange:function(eDat){   //  数据字典
            this.params[eDat.paramsKey] = eDat.name;
            this.params[eDat.paramsKey + "Id"] = eDat.id;
        },

        contentChange:function(e){    // 富文本内容
            this.params.context = e;
        },

        tagChange:function(e){
            this.params[e.paramsKey] = e.id;
        },

        goCreate:function(status){  // 创建
            var vues = this;
            this.params.status = status;
            pkCreate({enterpriseServicePack:this.params}).then(res => {
                vues.$router.push('pksvc_message');
            }).catch(err => {})
        },

        entSeek:function(e){
            var vues = this;
            var key = e.replace(/\s+/g,'');
            if(key){
              getEnterpriseList({
                 statusList:[1,2,4],
                 keyword:key,
                 sort:2,
                 no:1,
                 size:12
              }).then(res => {
                 vues.selectList2 = res.enterpriseList;
                 res.enterpriseList.forEach((item, i) => {
                     vues.entMap[item.id] = item;
                 });

              })
            }
        },

        entSelect:function(){
            let isSelected = false;
            this.idArr2.forEach((item, i) => {
                if(item.id == this.entId){
                    isSelected = true;
                    return;
                }
            });

            if(!isSelected){
                this.entMap[this.entId].name = this.entMap[this.entId].companyName;
                this.idArr2.push(this.entMap[this.entId]);
            }else{
                this.$message.error('已添加！');
            }

        },

        entRemove:function(inx){
            this.idArr2.splice(inx,1);
        },

        userSeek:function(e){
          var vues = this;
          var key = e.replace(/\s+/g,'');
          if(key){
            getEntUser({
               statusList:[1],
               keyword:key,
               sort:2,
               no:1,
               size:12
            }).then(res => {
               vues.selectList3 = res.enterprisePersonList;
               res.enterprisePersonList.forEach((item, i) => {
                   vues.userMap[item.id] = item;
               });

            })
          }
        },

        userSelect:function(){
            let isSelected = false;
            this.idArr3.forEach((item, i) => {
                if(item.id == this.userId){
                    isSelected = true;
                    return;
                }
            });

            if(!isSelected){
                this.idArr3.push(this.userMap[this.userId]);
            }else{
                this.$message.error('已添加！');
            }

        },

        userRemove:function(inx){
            this.idArr3.splice(inx,1);
        },

        directSave:function(status){
            var vues = this;
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                      vues.params.context = this.$refs.textEditor.editorContent;
                      if(!vues.params.context){
                          vues.$message.error('正文内容必须填写！');
                      }else{
                        var arrs = ['visibleRangeType','visibleRangeEnterprise','visibleRangeUser'];
                        if(vues.radioType == 2){
                            vues.params.visibleRangeType = vues.idArr1.join(',');
                            vues.params.visibleRangeEnterprise = '';
                            vues.params.visibleRangeUser = '';
                        }else if(vues.radioType == 3){
                            let newArr = [];
                            vues.idArr2.forEach((item, i) => {
                                let temp = {
                                    id:item.id,
                                    name:item.name
                                }
                                newArr.push(temp);
                            });
                            vues.params.visibleRangeType = '';
                            vues.params.visibleRangeUser = '';
                            vues.params.visibleRangeEnterprise = JSON.stringify(newArr);
                        }else if(vues.radioType == 4){
                            let newArr = [];
                            vues.idArr3.forEach((item, i) => {
                                let temp = {
                                    id:item.id,
                                    name:item.name,
                                    enterpriseName:item.enterpriseName,
                                }
                                newArr.push(temp);
                            });
                            vues.params.visibleRangeType = '';
                            vues.params.visibleRangeEnterprise = '';
                            vues.params.visibleRangeUser = JSON.stringify(newArr);
                        }
                        vues.goCreate(status);
                    }
                }
            })
        },


        imgChange:function(e){
            this.params.image = e;
        },

        entSeek:function(e){
            var vues = this;
            var key = e.replace(/\s+/g,'');
            if(key){
              getEnterpriseList({
                 status:'',
                 keyword:key,
                 sort:2,
                 no:1,
                 size:12,
                 identityTypeId:vues.entClassMap['凤鸣企业'].id
              }).then(res => {
                 vues.selectList2 = res.enterpriseList;
                 res.enterpriseList.forEach((item, i) => {
                     vues.entMap[item.id] = item;
                 });

              })
            }
        },

        entSelect:function(){
            let isSelected = false;
            this.idArr2.forEach((item, i) => {
                if(item.id == this.entId){
                    isSelected = true;
                    return;
                }
            });

            if(!isSelected){
                this.entMap[this.entId].name = this.entMap[this.entId].companyName;
                this.idArr2.push(this.entMap[this.entId]);
            }else{
                this.$message.error('已添加！');
            }

        },

        entRemove:function(inx){
            this.idArr2.splice(inx,1);
        },

        userSeek:function(e){
          var vues = this;
          var key = e.replace(/\s+/g,'');
          if(key){
            getEntUser({
               statusList:[1],
               keyword:key,
               sort:2,
               no:1,
               size:12
            }).then(res => {
               vues.selectList3 = res.enterprisePersonList;
               res.enterprisePersonList.forEach((item, i) => {
                   vues.userMap[item.id] = item;
               });

            })
          }
        },

        userSelect:function(){
            let isSelected = false;
            this.idArr3.forEach((item, i) => {
                if(item.id == this.userId){
                    isSelected = true;
                    return;
                }
            });

            if(!isSelected){
                let temp = {
                    id:this.userMap[this.userId].userId,
                    name:this.userMap[this.userId].name,
                    enterpriseName:this.userMap[this.userId].enterpriseName,
                }
                this.idArr3.push(temp);
            }else{
                this.$message.error('已添加！');
            }

        },

        userRemove:function(inx){
            this.idArr3.splice(inx,1);
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            // 底部定位
            this.pageFix();

            dicSeek({code:'sflx'}).then(res => {
                this.selectList1 = res.dataDictionarys;
                this.selectList1.forEach(item => {
                     this.entClassMap[item.name] = item;
                })
            })

            if(querys && querys.id){
                this.params.id = querys.id;
                pkPredat({id:querys.id}).then(res => {
                    vues.params = res.enterpriseServicePack;
                    var arrs = ['visibleRangeType','visibleRangeEnterprise','visibleRangeUser'];
                    arrs.forEach((item, i) => {
                        if(vues.params[item]){
                            vues.radioType = i + 2;
                            let tempArr = [];
                            if(i === 0){
                                tempArr = vues.params[item].split(',');
                            }else{
                                tempArr = JSON.parse(vues.params[item]);
                            };
                            vues['idArr' + (i+1)] = tempArr;
                        }
                    });
                });

                // vues.$emit('inited');
            }else{
                this.preCode = JSON.stringify(this.params);
            }

        }

    },
    created:function(){
        var vues = this;

        this.prevSet();
        $(window).resize(function(){
    		vues.pageFix();
            if(vues.$refs.scroller.$data){
                vues.$refs.scroller.$data.sizeHeight = this.pageH;
            }
    	})

    },

    beforeDestroy:function(){
        clearInterval(this.waitSave);
    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
  font-size: 15px;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.select-line{
  position: relative;
  margin-bottom: 20px;
  margin-top: 20px;
  .selectGp{
    display: inline-block;
    width: 32%;
    span{
      font-size: 15px;
      margin-right: 12px;
    }

    .cName{
       display: inline-block;
       width: 75px;
    }
  }
}


.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }
}

.text-block{
      font-size: 14px;
     .bName{
          width: 80px;
          padding-top: 8px;
          float: left
     }
     .bContent{
          margin-left: 80px;
          position: relative;
          .inpText{
               width: 420px;
          }
     }
}

.scene-block{
     margin-top: 45px;
}

.img-block{
    margin-top: 45px;
    margin-bottom: 45px;
}

.check-block{
    margin-top: 20px;
   .check-seek {
       .seek-head{
           position: relative;
           .el-icon-search{
               position: absolute;
               left: 15px;
               top: 12px;
               color: #dcdfe6;
               z-index: 2;
           }
           .el-select{
              width: 432px;
           }
       }
       .seek-body{
            .el-tag{
                margin-right: 12px;
                margin-top: 12px;
            }
       }
   }
}


</style>

<style lang="css">

  .pgInner.pk_edit .el-input__inner{
    border-radius: 0px !important;
  }

  .pgInner.pk_edit .select-line .el-input{
    width: 240px !important;
  }

  .pgInner.pk_edit .el-form-item{
    display: inline-block !important;
    margin-bottom: 0px;
  }

</style>



// WEBPACK FOOTER //
// pkSvcEdit.vue?2f7c2c89